//Here we are going to start merging all the icons into one file so that we can import them all at once
import completeSuccessIcon from "./icons/Custom-Successfull-16px-Green.svg";
import completeUnsuccessfulIcon from "./icons/Custom-Unsuccessfull-16px-Yellow.svg";
import businessEscalationIcon from "./icons/Custom-BusinessEscalation-16px-Blue.svg";
import followUpIcon from "./icons/Custom-FollowUp-16px-Blue.svg";
import addtionalOutreachIcon from "./icons/Custom-AdditionalOutreach-16px-Blue.svg";
import extensionGrantedIcon from "./icons/Custom-GrantExtension-16px-Blue.svg";
import completeIcon from "./icons/Icon - Complete.svg";
import DropdownArrow from "./icons/Icon - Dropdown Chevron - Down.svg";
import DropdownArrowDisabled from "./icons/Icon - Chevron - Down.svg";
import DropdownUpArrow from "./icons/Icon - Dropdown Chevron - Up.svg";
import ArrowDown from "./icons/ArrowDown.svg";
import ArrowUp from "./icons/ArrowUp.svg";
import ArrowHover from "./icons/ArrowHover.svg";
import DashboardEdit from "./icons/Icon-Dashboard-Edit-32px-Blue.svg";
import DashboardExport from "./icons/Icon-Dashboard-Export-32px-Blue.svg";
import DashboardExpand from "./icons/Icon-Dashboard-Expand-32px-Blue.svg";
import CollapseButton from "./icons/Button-Collapse-All.svg";
import ExpandButton from "./icons/Button-Expand-All.svg";
import High from "./icons/Icon-Capacity-High-32px.svg";
import Medium from "./icons/Icon-Capacity-Medium-32px.svg";
import Low from "./icons/Icon-Capacity-Low-32px.svg";
import MergersHigh from "./icons/Icon-Mergers-Capacity-High-32px.svg";
import MergersLow from "./icons/Icon-Mergers-Capacity-Low-32px.svg";
import GreenChechMark from "./icons/Icon-Checkmark-20px-Green.svg";
import ShiftsActivity from "./icons/Icon-Shifts-Activity-20px-Yellow.svg";
import CheckmarkSquare from "./icons/Icon-Checkmark-Square-20px-Green.svg";
import DismissSquare from "./icons/Icon-Dismiss-Square-20px-Red.svg";
import calendarIcon from "./icons/Icon - calender.svg";
import NoProjectsImage from "./icons/Illustration - Missing content.svg";
import ArrowRightIcon from "./icons/Icon - Navigation - Next.svg";
import ArrowDownIcon from "./icons/Icon - Navigation - Chevron - Down.svg";
import Refresh from "./icons/Icon-refresh-20px.svg";
import Refresh2 from "./icons/Icons - Navigation Refresh.svg";
import deleteButton from "./icons/Icon - Remove Tag.svg";
import GroupIcon from "./icons/Icons - Groups.svg";
import CompleteIconActive from "./icons/Icon-Complete-Active-16px-Blue-60.svg";
import ReopenIconActive from "./icons/Icon-Reopen-Active-16px-Blue-60.svg";
import ArchiveIconActive from "./icons/Icon-Archive-Active-16px-Blue-60.svg";
import UnarchiveIconActive from "./icons/Icon-Unarchive-Active-16px-Blue-60.svg";
import CompleteIconDisabled from "./icons/Icon-Complete-Disabled-16px-Gray-30.svg";
import ReopenIconDisabled from "./icons/Icon-Reopen-Disabled-16px-Gray-30.svg";
import ArchiveIconDisabled from "./icons/Icon-Archive-Disabled-16px-Gray-30.svg";
import UnarchiveIconDisabled from "./icons/Icon-Unarchive-Disabled-16px-Gray-30.svg";
import CompleteIcon from "./icons/Icon-Complete-56px-Gold-50.svg";
import ReopenIcon from "./icons/Icon - Action - Reopen - 20px.svg";
import ArchiveIcon from "./icons/Icon - Action - Archive w- hover - 20px.svg";
import UnarchiveIcon from "./icons/Icon - Action - Unarchive w- hover - 20px.svg";
import MicrosoftTeamsIcon from "./icons/Microsoft-Teams-Purple-16px.svg";

import {
  ClipboardTextLtrRegular,
  ClipboardTextEditFilled,
  ClipboardTaskFilled,
  FolderFilled,
  TasksAppFilled,
  ImageRegular,
  DocumentPdfRegular,
  ChartMultipleRegular,
  DocumentBulletListRegular,
  DocumentTableRegular,
  TextCaseTitleRegular,
  TextDescriptionRegular,
  CalendarRegular,
  HourglassHalfRegular,
  NumberSymbolRegular,
  NumberSymbolFilled,
  ToggleLeftRegular,
  CheckboxCheckedRegular,
  RadioButtonFilled,
  ChevronCircleDownRegular,
  ChevronDoubleDownRegular,
  LinkRegular,
  DocumentRegular,
  TableRegular,
  ArrowLeftRegular,
  EditRegular,
  ArrowDownloadRegular,
  EraserRegular,
  SaveRegular,
  FlashAutoRegular,
  ChevronLeftRegular,
  BotRegular,
  TextEditStyleRegular,
  SendRegular,
  WindowTextRegular,
  WindowTextFilled,
  AlertRegular,
  AlertFilled,
  TextBulletListSquareEditRegular,
  TextBulletListSquareEditFilled,
  FormMultipleRegular,
  FormMultipleFilled,
  SlideSettingsRegular,
  SlideSettingsFilled,
  FlowchartRegular,
  FlowchartFilled,
  SparkleRegular,
  SparkleFilled,
  AddRegular,
  InfoRegular,
  SearchRegular,
  InsertRegular,
  DeleteRegular,
  DeleteFilled,
  ChevronRightRegular,
  bundleIcon,
  MoreHorizontalRegular,
  FormRegular,
  RenameRegular,
  RenameFilled,
  OpenRegular,
  OpenFilled,
  SettingsRegular,
  SettingsFilled,
  DismissRegular,
  ArrowClockwiseFilled,
  ChevronDownRegular,
  ChevronUpRegular,
  DocumentArrowUpRegular,
  ImportantFilled,
  PeopleFilled,
  SlideSearchRegular,
  ApprovalsAppRegular,
  CalendarCheckmarkRegular,
  ArrowMaximizeRegular,
  FullScreenMaximizeFilled,
  FullScreenMinimizeFilled,
  ArchiveRegular,
  ArrowClockwiseRegular,
  ArrowResetRegular,
  CalendarArrowCounterclockwiseRegular,
  AppsListDetailRegular,
  PeopleRegular,
  ArrowRotateClockwiseRegular,
  ErrorCircleRegular,
  ArrowSyncRegular,
  ImportantRegular,
  CheckmarkCircleRegular,
  PersonSettingsRegular,
  EditFilled,
  FolderAddRegular,
  ThumbLikeRegular,
  Rocket24Filled,
  Fire20Filled,
  BowlChopsticks20Filled,
  TextAsterisk20Filled,
  Alert20Regular,
  TaskListRtlRegular,
  DraftsRegular,
  MailReadRegular,
  CallRegular,
  WindowConsoleRegular,
  CopyRegular,
  CheckmarkRegular,
  ClipboardTaskRegular,
  ToolboxRegular,
  FolderRegular,
  DataUsageRegular,
  EyeRegular,
  TagRegular,
  PeopleTeamRegular,
  SubtractRegular,
  NavigationRegular,
  PersonRegular,
  ArrowExitRegular,
  QuestionCircleRegular,
  ClipboardImageRegular
} from "@fluentui/react-icons";

export {
  completeSuccessIcon,
  completeUnsuccessfulIcon,
  businessEscalationIcon,
  followUpIcon,
  addtionalOutreachIcon,
  extensionGrantedIcon,
  completeIcon,
  DropdownArrow,
  DropdownArrowDisabled,
  DropdownUpArrow,
  ArrowUp,
  ArrowDown,
  ArrowHover,
  DashboardEdit,
  DashboardExport,
  DashboardExpand,
  CollapseButton,
  ExpandButton,
  High,
  Medium,
  Low,
  MergersHigh,
  MergersLow,
  GreenChechMark,
  ShiftsActivity,
  CheckmarkSquare,
  DismissSquare,
  calendarIcon,
  NoProjectsImage,
  ArrowRightIcon,
  ArrowDownIcon,
  Refresh,
  Refresh2,
  deleteButton,
  GroupIcon,
  CompleteIconActive,
  ReopenIconActive,
  ArchiveIconActive,
  UnarchiveIconActive,
  CompleteIconDisabled,
  ReopenIconDisabled,
  ArchiveIconDisabled,
  UnarchiveIconDisabled,
  CompleteIcon,
  ReopenIcon,
  ArchiveIcon,
  UnarchiveIcon,
  CalendarArrowCounterclockwiseRegular,
  PersonSettingsRegular,
  MicrosoftTeamsIcon,
  DraftsRegular,
  ClipboardTaskRegular,
  ToolboxRegular,
  FolderRegular,
  DataUsageRegular,
  TagRegular,
  ClipboardImageRegular
};

const WindowTextBundle = bundleIcon(WindowTextFilled, WindowTextRegular);
const AlertBundle = bundleIcon(AlertFilled, AlertRegular);
const TextBulletListSquareEditBundle = bundleIcon(
  TextBulletListSquareEditFilled,
  TextBulletListSquareEditRegular
);
const FormMultipleBundle = bundleIcon(FormMultipleFilled, FormMultipleRegular);
const SlideSettingsBundle = bundleIcon(
  SlideSettingsFilled,
  SlideSettingsRegular
);
const FlowchartBundle = bundleIcon(FlowchartFilled, FlowchartRegular);
const SparkleBundle = bundleIcon(SparkleFilled, SparkleRegular);
const DeleteBundle = bundleIcon(DeleteFilled, DeleteRegular);
const RenameBundle = bundleIcon(RenameFilled, RenameRegular);
const OpenBundle = bundleIcon(OpenFilled, OpenRegular);
const SettingsBundle = bundleIcon(SettingsFilled, SettingsRegular);

export const FluentIcons = {
  ClipboardTextLtrRegular: (props) => <ClipboardTextLtrRegular {...props} />,
  ClipboardTextEditFilled: (props) => <ClipboardTextEditFilled {...props} />,
  ClipboardTaskFilled: (props) => <ClipboardTaskFilled {...props} />,
  FolderFilled: (props) => <FolderFilled {...props} />,
  TasksAppFilled: (props) => <TasksAppFilled {...props} />,
  ImageRegular: (props) => <ImageRegular {...props} />,
  DocumentPdfRegular: (props) => <DocumentPdfRegular {...props} />,
  ChartMultipleRegular: (props) => <ChartMultipleRegular {...props} />,
  DocumentBulletListRegular: (props) => (
    <DocumentBulletListRegular {...props} />
  ),
  DocumentTableRegular: (props) => <DocumentTableRegular {...props} />,
  TextCaseTitleRegular: (props) => <TextCaseTitleRegular {...props} />,
  TextDescriptionRegular: (props) => <TextDescriptionRegular {...props} />,
  CalendarRegular: (props) => <CalendarRegular {...props} />,
  HourglassHalfRegular: (props) => <HourglassHalfRegular {...props} />,
  NumberSymbolRegular: (props) => <NumberSymbolRegular {...props} />,
  NumberSymbolFilled: (props) => <NumberSymbolFilled {...props} />,
  ToggleLeftRegular: (props) => <ToggleLeftRegular {...props} />,
  CheckboxCheckedRegular: (props) => <CheckboxCheckedRegular {...props} />,
  RadioButtonFilled: (props) => <RadioButtonFilled {...props} />,
  ChevronCircleDownRegular: (props) => <ChevronCircleDownRegular {...props} />,
  ChevronDoubleDownRegular: (props) => <ChevronDoubleDownRegular {...props} />,
  LinkRegular: (props) => <LinkRegular {...props} />,
  DocumentRegular: (props) => <DocumentRegular {...props} />,
  TableRegular: (props) => <TableRegular {...props} />,
  ArrowLeftRegular: (props) => <ArrowLeftRegular {...props} />,
  EditRegular: (props) => <EditRegular {...props} />,
  ArrowDownloadRegular: (props) => <ArrowDownloadRegular {...props} />,
  ChevronDownRegular: (props) => <ChevronDownRegular {...props} />,
  ChevronUpRegular: (props) => <ChevronUpRegular {...props} />,
  EraserRegular: (props) => <EraserRegular {...props} />,
  SaveRegular: (props) => <SaveRegular {...props} />,
  FlashAutoRegular: (props) => <FlashAutoRegular {...props} />,
  ChevronLeftRegular: (props) => <ChevronLeftRegular {...props} />,
  BotRegular: (props) => <BotRegular {...props} />,
  TextEditStyleRegular: (props) => <TextEditStyleRegular {...props} />,
  SendRegular: (props) => <SendRegular {...props} />,
  WindowTextBundle: (props) => <WindowTextBundle {...props} />,
  SettingsRegular: (props) => <SettingsRegular {...props} />,
  AlertBundle: (props) => <AlertBundle {...props} />,
  TextBulletListSquareEditBundle: (props) => (
    <TextBulletListSquareEditBundle {...props} />
  ),
  FormMultipleBundle: (props) => <FormMultipleBundle {...props} />,
  SlideSettingsBundle: (props) => <SlideSettingsBundle {...props} />,
  FlowchartBundle: (props) => <FlowchartBundle {...props} />,
  SparkleBundle: (props) => <SparkleBundle {...props} />,
  AddRegular: (props) => <AddRegular {...props} />,
  SubtractRegular: (props) => <SubtractRegular {...props} />,
  InfoRegular: (props) => <InfoRegular {...props} />,
  SearchRegular: (props) => <SearchRegular {...props} />,
  InsertRegular: (props) => <InsertRegular {...props} />,
  DeleteRegular: (props) => <DeleteRegular {...props} />,
  ChevronRightRegular: (props) => <ChevronRightRegular {...props} />,
  MoreHorizontalRegular: (props) => <MoreHorizontalRegular {...props} />,
  FormRegular: (props) => <FormRegular {...props} />,
  DeleteBundle: (props) => <DeleteBundle {...props} />,
  RenameBundle: (props) => <RenameBundle {...props} />,
  OpenBundle: (props) => <OpenBundle {...props} />,
  SettingsBundle: (props) => <SettingsBundle {...props} />,
  DismissRegular: (props) => <DismissRegular {...props} />,
  ArrowClockwiseFilled: (props) => <ArrowClockwiseFilled {...props} />,
  ArrowClockwiseRegular: (props) => <ArrowClockwiseRegular {...props} />,
  ArrowResetRegular: (props) => <ArrowResetRegular {...props} />,
  DocumentArrowUpRegular: (props) => <DocumentArrowUpRegular {...props} />,
  ImportantFilled: (props) => <ImportantFilled {...props} />,
  PeopleFilled: (props) => <PeopleFilled {...props} />,
  SlideSearchRegular: (props) => <SlideSearchRegular {...props} />,
  ApprovalsAppRegular: (props) => <ApprovalsAppRegular {...props} />,
  CalendarCheckmarkRegular: (props) => <CalendarCheckmarkRegular {...props} />,
  ArrowMaximizeRegular: (props) => <ArrowMaximizeRegular {...props} />,
  FullScreenMaximizeFilled: (props) => <FullScreenMaximizeFilled {...props} />,
  FullScreenMinimizeFilled: (props) => <FullScreenMinimizeFilled {...props} />,
  ArchiveRegular: (props) => <ArchiveRegular {...props} />,
  CalendarArrowCounterclockwiseRegular: (props) => <CalendarArrowCounterclockwiseRegular {...props} />,
  AppsListDetailRegular: (props) => <AppsListDetailRegular {...props} />,
  PeopleRegular: (props) => <PeopleRegular {...props} />,
  ArrowRotateClockwiseRegular: (props) => (<ArrowRotateClockwiseRegular {...props} />),
  ErrorCircleRegular: (props) => <ErrorCircleRegular {...props} />,
  ArrowSyncRegular: (props) => <ArrowSyncRegular {...props} />,
  ImportantRegular: (props) => <ImportantRegular {...props} />,
  CheckmarkCircleRegular: (props) => <CheckmarkCircleRegular {...props} />,
  PersonSettingsRegular: (props) => <PersonSettingsRegular {...props} />,
  EditFilled: (props) => <EditFilled {...props} />,
  FolderAddRegular: (props) => <FolderAddRegular {...props} />,
  ThumbLikeRegular: (props) => <ThumbLikeRegular {...props} />,
  Rocket24Filled: (props) => <Rocket24Filled {...props} />,
  Fire20Filled: (props) => <Fire20Filled {...props} />,
  BowlChopsticks20Filled: (props) => <BowlChopsticks20Filled {...props} />,
  TextAsterisk20Filled: (props) => <TextAsterisk20Filled {...props} />,
  Alert20Regular: (props) => <Alert20Regular {...props} />,
  TaskListRtlRegular: (props) => <TaskListRtlRegular {...props} />,
  DraftsRegular: (props) => <DraftsRegular {...props} />,
  MailReadRegular: (props) => <MailReadRegular {...props} />,
  CallRegular: (props) => <CallRegular {...props} />,
  WindowConsoleRegular: (props) => <WindowConsoleRegular {...props} />,
  CopyRegular: (props) => <CopyRegular {...props} />,
  CheckmarkRegular: (props) => <CheckmarkRegular {...props} />,
  ClipboardTaskRegular: (props) => <ClipboardTaskRegular {...props} />,
  ToolboxRegular: (props) => <ToolboxRegular {...props} />,
  FolderRegular: (props) => <FolderRegular {...props} />,
  DataUsageRegular: (props) => <DataUsageRegular {...props} />,
  EyeRegular: (props) => <EyeRegular {...props} />,
  TagRegular: (props) => <TagRegular {...props} />,
  PeopleTeamRegular: (props) => <PeopleTeamRegular {...props} />,
  NavigationRegular: (props) => <NavigationRegular {...props} />,
  PersonRegular: (props) => <PersonRegular {...props} />,
  ArrowExitRegular: (props) => <ArrowExitRegular {...props} />,
  QuestionCircleRegular: (props) => <QuestionCircleRegular {...props} />,
  ClipboardImageRegular: (props) => <ClipboardImageRegular {...props} />
};
